import React, { PureComponent } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { string, func, oneOfType, node } from 'prop-types';
import Icon from '../Icon/Icon';

class ListFilter extends PureComponent {
  static propTypes = {
    onChange: func.isRequired,
    tag: oneOfType([string, node]),
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    onChange() {},
    tag: 'div',
  };

  state = {
    query: '',
  };

  handleChange = (e) => {
    const { target } = e;
    const query = target.value.toLowerCase().trim();

    this.setState(
      () => ({
        query,
      }),
      () => {
        this.props.onChange(query);
      },
    );
  };

  renderPlaceholder = () => {
    const { intl } = this.props;
    return intl.formatMessage({
      id: 'main.search',
      defaultMessage: 'Search',
    });
  };

  render() {
    const { query } = this.state;
    const { tag: Tag } = this.props;

    return (
      <Tag className="filter-search">
        <Icon type="search" />
        <input
          className="filter-search"
          name="query"
          onChange={this.handleChange}
          value={query}
          placeholder={this.renderPlaceholder()}
          autoComplete="off"
        />
      </Tag>
    );
  }
}

export default injectIntl(ListFilter);
